import { createRequestTypes } from 'common/websocket-redux';

export const GET_SSO_VENDOR_DETAILS = 'websocket/GET_SSO_VENDOR_DETAILS';

export const REQUEST_SSO_VENDOR_DETAILS = createRequestTypes(
  'websocket/REQUEST_SSO_VENDOR_DETAILS',
);
